/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    import IAgreement       = DealerwareWebContent.IAgreement;
    import IAgreementPage   = DealerwareWebContent.IAgreementPage;

    export interface IViewPageNavigatorScope extends ng.IScope {
        agreement                                       : IAgreement;
        selectedPage                                    : IAgreementPage;
        setSignatureDateCoordinates (coordinates: any)  : void;
        onSelectionBoxSizing (box: any)                 : void;
        getPageImageStyle ()                            : any;
    }

    export class SettingsLoanerAgreementViewPageNavigatorController {

        public static $inject : string[ ] = [
            '$scope', '$controller', 'DataUtils', '$dealerwareNotification', '$dealerwareInternationalizationData'
        ];

        private utils               : any;
        private agreementSelections : any;
        public labels               : any;

        constructor(
            private $scope      : IViewPageNavigatorScope,
            private $controller : ng.IControllerService,
            private DataUtils   : any,
            public $dealerwareNotification: any,
            public $dealerwareInternationalizationData: any
        ) {
            this.getLabels('agreement');

            this.utils = this.DataUtils.getInstance();

            this.$scope.getPageImageStyle = this.getPageImageStyle;

            this.agreementSelections = $controller(
                'AgreementSelectionsController', { $scope: this.$scope }
            );

            this.$scope.onSelectionBoxSizing = this.onSelectionBoxSizing;
        }

        public getLabels(module: string) : void {
            this.$dealerwareInternationalizationData
                .getLabels()
                .then((res: any) => {
                    this.labels = this.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                })
                .catch((error: any) => {
                    this.$dealerwareNotification.apiError(error);
                });
        }

        public getPageImageStyle () : any {

            var that = this;

            return ( ) => {

                return that.$scope.selectedPage && that.$scope.selectedPage.thumbnailHeight && that.$scope.selectedPage.thumbnailWidth ? {
                    height  : that.$scope.selectedPage.thumbnailHeight / 2,
                    width   : that.$scope.selectedPage.thumbnailWidth / 2,
                } : { };
            };
        }

        public setSignatureDateCoordinates ( box: any ) : void {

            this.$scope.setSignatureDateCoordinates( {
                stepName        : box.id,
                coordinateData  : box
            } );
        }

        public clickUploadButton () : void {
            angular.element('.drop-box').trigger('click');
        }

        public disableSelectionBoxMove () : boolean {
            return true;
        }

        public onSelectionBoxCreated (box: any) : any {

            // It isn't so great to rely on what the controller including AgreementSelectionsController
            // (via $controller, e.g. DefineSignatureDateController) calls this controller as one of its properties
            // and then hardwiring it here.
            //
            this.agreementSelections.activeSelectionId = box.id === 'set-date' ? 'set-signature' : 'set-date';

            // To get these half-size boxes to appear to be in the same place as the half-size
            // contract page "thumbnail", the border width needs to be chopped off as part of making
            // the top and left calculations for the boxes.
            //
            // And parse the border-width string.  Ugh.
            //
            var borderWidth = (parseInt(box.element.css('border-width').replace(/px/,''), 10));

            box.top     /= 2;
            box.left    /= 2;
            box.width   /= 2;
            box.height  /= 2;

            box.element.css('top', box.top + borderWidth);
            box.element.css('left', box.left + borderWidth);

            box.element.css('width', box.width);
            box.element.css('height', box.height);
        }

        // Box sizing callback changes the size of the element inside the box as the box
        // itself changes dimensions, i.e. the signature or date mockup images.
        //
        public onSelectionBoxSizing (box: any) : void {

            if (box.content) {
                var borderWidth = (parseInt(box.element.css('border-width').replace(/px/,''), 10));
                box.content.element.css('width', box.width - 2 * borderWidth);
                box.content.element.css('height', box.height - 2 * borderWidth);
            }
        }

        public createdAt () : string {
            if (!this.$scope.agreement) return '--';

            return moment(this.$scope.agreement.createdAt).format('YYYY-MM-DD, HH:mm');
        }
    }

    export class SettingsLoanerAgreementViewPageNavigatorDirective implements ng.IDirective {

        public restrict     : string    = 'E';
        public controller   : any       = 'SettingsLoanerAgreementViewPageNavigatorController';
        public controllerAs : string    = 'ctrl';
        public scope        : Object    = {

            agreement           : '=',

            // Checking for various data and page states.
            //
            isPageSelected      : '&',
            isSignatureDefined  : '&',
            isDateDefined       : '&',
            checkThisStep       : '&',

            // Doing actions against data (agreement) and page states.
            //
            getSelectedPageUrl  : '&',
            getPageImageStyle   : '&?',
            goToPage            : '&',

            // Methods in set-directive to handle actions on selectedPage.
            //
            setSignatureDateCoordinates     : '&',
            deleteSignatureDateCoordinates  : '&',

            isCoordinateDataChanged: '&',

            activeSelectionId           : '=',
            selectedPage                : '='
        };
        public templateUrl  : string    = '/components/settings/loaner-agreement/view-page-navigator-directive.html';
    }

    getDealerwareWebComponentsModule().controller(
        'SettingsLoanerAgreementViewPageNavigatorController',
        SettingsLoanerAgreementViewPageNavigatorController
    );

    getDealerwareWebComponentsModule().directive(
        'dealerwareLoanerAgreementViewPageNavigator',
        ( ) => new SettingsLoanerAgreementViewPageNavigatorDirective()
    );
}
